/* Vomuray front-end helpers (vanilla, no deps) */
(function () {
  'use strict';
  const money = (cents, fmt) => {
    const v = (cents / 100).toFixed(2);
    return (fmt || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v);
  };
  // ---- current variant tracking (Dawn updates input[name=id] on change)
  const productForm = () => document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"]');
  const currentVariantId = () => { const f = productForm(); const i = f && f.querySelector('input[name="id"]'); return i ? String(i.value) : null; };
  const listeners = [];
  const onVariant = (fn) => { listeners.push(fn); fn(currentVariantId()); };
  let last = null;
  const check = () => { const id = currentVariantId(); if (id !== last) { last = id; listeners.forEach(fn => fn(id)); } };
  document.addEventListener('change', () => { setTimeout(check, 50); setTimeout(check, 400); });
  setInterval(check, 800);
  // shared helpers for component scripts (vm-*.js): window.VM.money(cents, fmt), VM.onVariant(fn), VM.currentVariantId(), VM.productForm(), VM.qty()
  const qtyInput = () => document.querySelector('input[data-vm-qty]');
  const qty = () => { const q = qtyInput(); const n = q ? parseInt(q.value, 10) : 1; return n > 0 ? n : 1; };
  const pct = () => { const q = qtyInput(); const p = q ? parseFloat(q.dataset.vmPct || '0') : 0; return p > 0 ? p : 0; };
  const freePairs = () => { const q = qtyInput(); const f = q ? parseInt(q.dataset.vmFree || '0', 10) : 0; return f > 0 ? f : 0; };
  window.VM = Object.assign(window.VM || {}, { money, onVariant, currentVariantId, productForm, qty, pct, freePairs });
  document.addEventListener('vm:tier', () => { last = null; check(); });
  // ---- size guide link -> open inline chart
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-vm-sizeguide]'); if (!b) return;
    e.preventDefault(); const d = document.querySelector('.vm-acc--chart'); if (!d) return;
    d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  // ---- you-save pill + low stock (snippet vm-price) + price inside the add-to-cart button
  document.querySelectorAll('.vm-price[data-variants]').forEach(el => {
    let variants = []; try { variants = JSON.parse(el.dataset.variants); } catch (e) { return; }
    const fmt = el.dataset.moneyFormat; const threshold = parseInt(el.dataset.lowStock || '6', 10);
    const save = el.querySelector('.vm-price__save'); const stock = el.querySelector('.vm-price__stock');
    const priceInButton = (v) => {
      const btn = document.querySelector('.product-form__submit'); if (!btn || !v) return;
      const span = btn.querySelector('span'); if (!span) return;
      if (btn.disabled || btn.classList.contains('vm-needs-size') || document.documentElement.dataset.vmBundleActive === '1') { const p = span.querySelector('.vm-atc-price'); if (p) p.remove(); return; }
      const q = qty(), d = pct(), fr = freePairs(); const total = fr > 0 ? v.price * (q - fr) : Math.round(v.price * q * (1 - d / 100));
      const label = q > 1 ? 'Add ' + q + ' pairs' : ((window.variantStrings && window.variantStrings.addToCart) || 'Add to cart');
      let p = span.querySelector('.vm-atc-price'); if (!p) { span.textContent = label; p = document.createElement('em'); p.className = 'vm-atc-price'; span.appendChild(p); }
      else { const first = span.firstChild; if (first && first.nodeType === 3 && first.textContent.trim() !== label) first.textContent = label; }
      p.textContent = ' — ' + money(total, fmt);
    };
    onVariant(id => {
      const v = variants.find(x => String(x.id) === String(id)) || variants[0]; if (!v) return;
      if (save) { if (v.compare_at_price && v.compare_at_price > v.price) { const d = v.compare_at_price - v.price; save.textContent = 'Save ' + money(d, fmt) + ' (' + Math.round(d * 100 / v.compare_at_price) + '%)'; save.hidden = false; } else save.hidden = true; }
      if (stock) { if (v.tracked && v.available && v.inventory_quantity > 0 && v.inventory_quantity < threshold) { stock.textContent = 'Only ' + v.inventory_quantity + ' pieces left'; stock.hidden = false; } else stock.hidden = true; }
      priceInButton(v); setTimeout(() => priceInButton(v), 600);
    });
    setInterval(() => { const v = variants.find(x => String(x.id) === String(currentVariantId())); if (v) priceInButton(v); }, 1500);
  });
  // ---- explicit size selection: no size preselected until the shopper taps one (prevents wrong-size orders)
  (function () {
    if (/[?&]variant=/.test(location.search)) return;
    const sizeFs = () => document.querySelector('.vm-opt--size'); if (!sizeFs() || !sizeFs().querySelector('input[type=radio]') || !productForm()) return; // size is a native dropdown (pre-selected) -> no gate needed
    let chosen = false; const submit = () => document.querySelector('.product-form__submit');
    const apply = () => {
      if (chosen) return;
      if (document.documentElement.dataset.vmBundleActive === '1') { const b = submit(); if (b) { b.disabled = false; b.removeAttribute('aria-disabled'); b.classList.remove('vm-needs-size'); } const sb = document.querySelector('.vm-sticky__btn'); if (sb) { delete sb.dataset.needsSize; sb.disabled = false; } return; }
      const fs = sizeFs(); if (!fs) return;
      fs.querySelectorAll('input[type=radio]:checked').forEach(i => { i.checked = false; });
      const b = submit(); if (b) { b.disabled = false; b.setAttribute('aria-disabled', 'true'); b.classList.add('vm-needs-size'); const s = b.querySelector('span'); if (s && !/Select your size/.test(s.textContent)) s.textContent = 'Select your size'; }
      document.querySelectorAll('.product-form__buttons .shopify-payment-button, .product-form__buttons [data-shopify="payment-button"]').forEach(e => e.classList.add('vm-hidden'));
      const sb = document.querySelector('.vm-sticky__btn'); if (sb) { sb.textContent = 'Select size'; sb.dataset.needsSize = '1'; sb.disabled = false; }
    };
    const release = () => {
      chosen = true; const b = submit(); if (b) { b.disabled = false; b.removeAttribute('aria-disabled'); b.classList.remove('vm-needs-size'); const s = b.querySelector('span'); if (s) s.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart'; }
      document.querySelectorAll('.vm-hidden').forEach(e => e.classList.remove('vm-hidden'));
      const sb = document.querySelector('.vm-sticky__btn'); if (sb) { sb.textContent = sb.dataset.label; delete sb.dataset.needsSize; }
      const fs = sizeFs(); fs && fs.classList.remove('vm-opt--attention');
    };
    document.addEventListener('change', e => { if (e.target.matches && e.target.matches('.vm-opt--size input[type=radio]') && e.target.checked) release(); });
    // a click on the disabled button (or the sticky "Select size") scrolls to the sizes and nudges them
    document.addEventListener('click', e => {
      const b = e.target.closest('.product-form__submit.vm-needs-size, .vm-sticky__btn[data-needs-size]'); if (!b) return;
      e.preventDefault(); e.stopImmediatePropagation(); const fs = sizeFs(); if (!fs) return;
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' }); fs.classList.remove('vm-opt--attention'); void fs.offsetWidth; fs.classList.add('vm-opt--attention');
    }, true);
    apply(); setInterval(apply, 400);
  })();
  // ---- sticky add to cart (section vm-sticky-atc)
  const sticky = document.querySelector('.vm-sticky');
  if (sticky) {
    const target = document.querySelector('.product-form__submit, product-form button[type=submit]');
    const btn = sticky.querySelector('.vm-sticky__btn');
    const sub = sticky.querySelector('.vm-sticky__sub');
    let variants = []; try { variants = JSON.parse(sticky.dataset.variants || '[]'); } catch (e) {}
    const fmt = sticky.dataset.moneyFormat;
    onVariant(id => { const v = variants.find(x => String(x.id) === String(id)); if (v && sub) sub.textContent = (v.title && v.title !== 'Default Title' ? v.title + ' · ' : '') + money(v.price, fmt); if (btn) { btn.disabled = v ? !v.available : false; btn.textContent = v && !v.available ? 'Sold out' : btn.dataset.label; } });
    if (target) { let ticking = false; const update = () => { ticking = false; const t = document.querySelector('.product-form__submit, product-form button[type=submit]') || target; const r = t.getBoundingClientRect(); const show = r.bottom < 0 || r.top > window.innerHeight; sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true'); }; window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true }); update(); }
    btn && btn.addEventListener('click', () => { const f = productForm(); if (!f) return; const s = f.querySelector('[type=submit]'); s ? s.click() : f.requestSubmit(); });
  }
  // ---- cart upsell add (snippet vm-cart-upsell): posts to /cart/add then asks Dawn to refresh
  document.addEventListener('click', e => {
    const b = e.target.closest('.vm-upsell__btn[data-variant-id]'); if (!b) return;
    e.preventDefault(); b.disabled = true;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: b.dataset.variantId, quantity: 1 }) })
      .then(r => r.json()).then(() => { const d = document.querySelector('cart-drawer'); if (d && typeof d.renderContents === 'function') { return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble').then(r => r.json()).then(sections => d.renderContents({ sections })); } window.location.reload(); })
      .catch(() => { b.disabled = false; });
  });
})();

/* ===== vm-pdp-editorial.js ===== */
/* Vomuray pdp-editorial (vm-wear-it, vm-materials, vm-fit-sizing): size-grid jump, open size chart, image reveal. No globals. */
(function () {
  'use strict';
  if (!document.querySelector('.vm-pdp-editorial')) return;
  var reduce = false;
  try { reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  // ---- the size chart inside vm-fit-sizing is rendered open in Liquid; this only keeps it open (its summary is hidden by CSS)
  var openCharts = function (root) {
    (root || document).querySelectorAll('.vm-fit-sizing details').forEach(function (d) { if (!d.open) d.open = true; });
  };
  openCharts();
  // toggle does not bubble, so listen in the capture phase
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.matches && d.matches('.vm-fit-sizing details') && !d.open) d.open = true;
  }, true);

  // ---- "Choose your size": scroll to the size grid, nudge it (same class base vm.js uses), move focus to the first available size
  var sizeTarget = function () {
    return document.querySelector('.vm-opt--size') ||
      document.querySelector('.product-form__buttons') ||
      (window.VM && typeof window.VM.productForm === 'function' ? window.VM.productForm() : null);
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-vm-scroll-size]') : null;
    if (!b) return;
    e.preventDefault();
    var t = sizeTarget();
    if (!t) return;
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    if (!t.classList.contains('vm-opt--size')) return;
    var checked = t.querySelector('input[type=radio]:checked');
    // nudge only while no size is chosen: base vm.js clears the class on the radio "change", which never fires for an already-selected size
    if (!checked) {
      t.classList.remove('vm-opt--attention');
      void t.offsetWidth;
      t.classList.add('vm-opt--attention');
    }
    var first = checked || t.querySelector('input[type=radio]:not(.disabled)');
    if (first) {
      setTimeout(function () {
        try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); }
      }, reduce ? 0 : 450);
    }
  });

  // ---- image reveal on scroll (CSS hides [data-vm-reveal] only under html.js; everything is shown on fallback)
  var show = function (el) { el.classList.add('is-inview'); };
  var reveal = function (root) {
    var items = (root || document).querySelectorAll('.vm-pdp-editorial [data-vm-reveal]:not(.is-inview)');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) { items.forEach(show); return; }
    try {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting || en.intersectionRatio > 0) { show(en.target); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      items.forEach(function (el) { io.observe(el); });
    } catch (err) { items.forEach(show); }
  };
  reveal();

  // ---- theme editor: sections are re-rendered on edit
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target || document;
    openCharts(root);
    root.querySelectorAll('.vm-pdp-editorial [data-vm-reveal]').forEach(show);
  });
})();


/* ===== vm-reviews.js ===== */
/* vm-reviews: "Show more" reveal on the product reviews grid + arrows for the home reviews wall. No deps, no globals. */
(function () {
  'use strict';
  if (!document.querySelector('.vm-reviews, .vm-reviews-wall')) return;

  // ---- product section: reveal the next batch of hidden cards (no reload)
  var revealBatch = function (root) {
    var per = parseInt(root.dataset.perPage || '6', 10) || 6;
    var hidden = Array.prototype.slice.call(root.querySelectorAll('.vm-reviews__grid > .vm-review[hidden]'));
    hidden.slice(0, per).forEach(function (card) { card.hidden = false; });
    var left = hidden.length - Math.min(per, hidden.length);
    var btn = root.querySelector('[data-vm-reviews-more]');
    if (!btn) return;
    if (left <= 0) {
      var wrap = btn.closest('.vm-reviews__actions');
      (wrap || btn).remove();
    } else {
      var n = btn.querySelector('.vm-reviews__more-n');
      if (n) n.textContent = '(' + left + ')';
    }
    var first = hidden[0];
    if (first) {
      first.setAttribute('tabindex', '-1');
      first.focus({ preventScroll: true });
    }
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vm-reviews-more]');
    if (!btn) return;
    var root = btn.closest('.vm-reviews');
    if (root) revealBatch(root);
  });

  // theme editor: selecting a hidden review block should bring it into view
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('.vm-review[hidden]') : null;
    if (card) card.hidden = false;
  });

  // ---- home wall: arrows + disabled state at the ends
  var step = function (track) {
    var card = track.querySelector('.vm-review');
    var gap = 16;
    return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.9;
  };

  var syncArrows = function (wall) {
    var track = wall.querySelector('[data-vm-wall-track]');
    var prev = wall.querySelector('[data-vm-wall-prev]');
    var next = wall.querySelector('[data-vm-wall-next]');
    if (!track || !prev || !next) return;
    var max = track.scrollWidth - track.clientWidth;
    var overflow = max > 2;
    prev.disabled = !overflow || track.scrollLeft <= 2;
    next.disabled = !overflow || track.scrollLeft >= max - 2;
    wall.classList.toggle('vm-reviews-wall--static', !overflow);
    track.tabIndex = overflow ? 0 : -1; // a row that cannot scroll should not be a tab stop
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vm-wall-prev], [data-vm-wall-next]');
    if (!btn) return;
    var wall = btn.closest('.vm-reviews-wall');
    var track = wall && wall.querySelector('[data-vm-wall-track]');
    if (!track) return;
    var dir = btn.hasAttribute('data-vm-wall-next') ? 1 : -1;
    track.scrollBy({ left: dir * step(track), behavior: 'smooth' });
  });

  // binding is tracked on the node itself: section:load swaps in a new node, nodes that survive keep their listeners
  var init = function () {
    Array.prototype.forEach.call(document.querySelectorAll('.vm-reviews-wall'), function (wall) {
      if (wall.dataset.vmBound) return;
      wall.dataset.vmBound = '1';
      var track = wall.querySelector('[data-vm-wall-track]');
      if (!track) return;
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; syncArrows(wall); });
      };
      track.addEventListener('scroll', onScroll, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          track.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * step(track), behavior: 'smooth' });
        }
      });
      syncArrows(wall);
    });
  };

  var resizeTimer = 0;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll('.vm-reviews-wall'), syncArrows);
    }, 120);
  });

  init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', function () {
    Array.prototype.forEach.call(document.querySelectorAll('.vm-reviews-wall'), syncArrows);
  });
})();

